<template>
  <div :id="containerId"></div>
</template>
<script>
import * as V3DApp from '../verge3d/app.js'
export default {
  name: 'V3DApp',
  props: {
    scene: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      containerId: V3DApp.CONTAINER_ID,
      camera: null
    }
  },
  vergeApp: null,
  mounted: function() {
    var REL_URL_PREFIX = `/vergescenes/${this.scene.name}/`
    var FILE_TYPE = this.scene.compressed ? 'gltf.xz' : 'gltf'
    var FILE_PATH = `/vergescenes/${this.scene.name}/${this.scene.name}.${FILE_TYPE}`
    const PUZZLES_ENABLED = this.scene.puzzles ? this.scene.puzzles : false
    this.$options.vergeApp = V3DApp.createApp(
      REL_URL_PREFIX,
      FILE_PATH,
      PUZZLES_ENABLED
    )
  },
  beforeDestroy() {
    this.$options.vergeApp.dispose()
  }
}
</script>

<style>
#v3d-container {
  position: absolute;
  top: -48px;
  left: 0px;
  width: 100%;
  height: 100vh;
}

.fullscreen-button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  background-size: 100% 100%;
  display: none;
  z-index: 1;
}

.fullscreen-open {
  background-image: url('/verge3d/3dcube/media/fullscreen_open.svg');
}

.fullscreen-close {
  background-image: url('/verge3d/3dcube/media/fullscreen_close.svg');
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* can import the verge css as well if somehow needed */
/* @import '../verge3d/app.css'; */
.v3d-simple-preloader-background {
  background: #01000a;
}

.v3d-simple-preloader-logo {
  background-image: url('/images/virtueinnovations.png');
  background-size: cover;
}

.v3d-simple-preloader-bar {
  background: white;
}
</style>
